<div class="container-fluid px-0 h-100">
  <div class="h-100  d-flex  justify-content-between">
    <div class="flex-grow-1 px-3 container_content">
      <form class="h-100">
        <div class="row justify-content-center">
          <div class="m-w-520 h-100 col-12">
            <!-- image -->
            <div class="col-12 mt-0 px-0 pt-5">
              <img src="assets/img/svg/logo_login.svg" alt="" srcset="">
            </div>
            <div class="row pt-3 pb-2  h-100 flex-wrap">


              <ng-container [formGroup]="signUpForm" [ngSwitch]="currentView">
                <!-- step 1 -->
                <ng-container *ngSwitchCase="'view1'">
                  <div class="col-12 mt-5 mb-4">
                    <h1 currentView id="registerHeading" class="h1 f-w-800">
                      Be a part of the <br /> <span style="color:var(--d-blue)"><span
                          class="notranslate">Denefits</span>
                        family!</span>
                    </h1>
                  </div>
                  <div class="col-12 mt-3 mb-4">
                    <h1 class="f-w-600 text-left mb-3 light-black" style="font-size: 18px;">What best describes you?
                    </h1>
                    <div class="d-flex flex-column justify-content-between align-items-start">
                      <div
                        class="d-flex justify-content-between align-items-center  py-4 px-3 col-12 pointer hover_class"
                        (click)="ForwardSingupValue('view1','view2');signup_type='business'"
                        style="border-radius: 10px;">
                        <div class="d-flex justify-content-between align-items-center p-0" style="width:75%">
                          <img src="assets\img\png\Group.png" alt="" width="40px">
                          <!-- <h1 class="f-w-600 text-left light-black fs-166 m-0 p-0 hover_class1" style="width: 75%;">I am a business
                            <span>Grow my customer base and manage everything in one place</span>
                          </h1> -->
                          <div style="margin-left: 30px;">
                            <h3 class="f-w-600 text-left light-black fs-166 m-0 p-0 hover_class1" style="width: 75%;">I'm a Business</h3>
                            <p class="pt-2 fw-400 m-0 fs-18">Grow my customer base and manage everything in one place</p>
                          </div>
                        </div>
                        <div class="p-0">
                          <img src="assets\img\svg\arrow-left.svg" alt="" width="50px">
                        </div>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center  py-4 px-3 col-12 mt-3 pointer hover_class"
                        style="border-radius: 10px;" routerLink="/customer-landing" >
                        <div class="d-flex justify-content-between align-items-center p-0" style="width: 81%;">
                          <img src="assets\img\png\Group (1).png" alt="" width="40px">
                          <!-- <h1 class="f-w-400 text-left light-black fs-166 p-0 m-0 hover_class1" style="width: 75%;">I am
                            a customer
                            looking for financing
                            options</h1> -->
                            <div style="margin-left: 30px;">
                              <h3 class="f-w-600 text-left light-black fs-166 m-0 p-0 hover_class1" style="width: 75%;">I'm a Customer</h3>
                              <p class="pt-2 fw-400 m-0 fs-18">Access services in a more affordable way</p>
                            </div>
                        </div>
                        <div class="p-0">
                          <img src="assets\img\svg\arrow-left.svg" alt="" width="50px">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 h6 text-left f-c-p-1 f-w-800 mt-4">
                    Already have an account? <a routerLink="/login" class="f-w-600" tabindex="-100000">Sign
                      In</a>
                  </div>
                </ng-container>

                <!-- step 2 -->
                <ng-container formGroupName="first_page" *ngSwitchCase="'view2'">
                  <!-- back -->
                  <div class="row mt-5 mb-4">
                    <div class="col-12 d-flex align-items-center pointer">
                      <img *ngIf="!referral_show" src="assets/img/png/arrow-left1.png" alt="Back" (click)="BackSingupValue('view1','view2')" />
                      <h1 class="Back_button p-0 m-0 ms-3">Enter Details</h1>
                    </div>
                  </div>

                  <div class="row g-3">
                    <!-- First Name -->
                    <div class="col-md-6">
                      <div
                        [ngClass]="[signUpForm && signUpForm.get('first_page.doctor_first_name').touched &&  signUpForm.get('first_page.doctor_first_name').invalid  ? ' inputContainer custom-form ' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" name="doctor_first_name" autocomplete="off"
                          required name="doctor_first_name" maxlength="30" formControlName="doctor_first_name"
                          id="registerFirstName" (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            First Name*
                          </span>
                        </label>
                      </div>
                      <!-- Error First Name -->
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('first_page.doctor_first_name').invalid && signUpForm.get('first_page.doctor_first_name').touched">
                        Please enter valid first name.
                      </p>

                    </div>
                    <!-- Last Name -->
                    <div class="col-md-6">
                      <div
                        [ngClass]="[ signUpForm.get('first_page.doctor_last_name').touched && signUpForm.get('first_page.doctor_last_name').invalid  ? 'inputContainer custom-form ' : 'custom-form']">
                        <input type="text" class="input_field pt-3 px-3" name="doctor_last_name" autocomplete="off"
                          required name="doctor_last_name" maxlength="30" formControlName="doctor_last_name"
                          id="registerLastName" (keypress)="mainService.handleInputSpace($event)" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Last Name*
                          </span>
                        </label>
                      </div>
                      <!-- Error Last Name -->
                      <p class="mat-error mb-0"
                        *ngIf="signUpForm.get('first_page.doctor_last_name').invalid && signUpForm.get('first_page.doctor_last_name').touched">
                        Please enter valid last name.
                      </p>
                    </div>
                    <!-- Email -->
                    <div class="col-12">
                      <div
                        [ngClass]="[ (signUpForm.get('first_page.doctor_email').touched && signUpForm.get('first_page.doctor_email').invalid || signUpForm.get('first_page.doctor_email').errors?.email_exists) ? 'custom-form inputContainer' : 'custom-form ']">
                        <input type="text" class="input_field px-3 pt-3" required name="doctor_email" maxlength="50"
                          trim formControlName="doctor_email" autocomplete="off" id="doctor_email" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Email*
                          </span>
                        </label>
                      </div>
                      <!-- Error Email -->
                      <p class="mat-error mb-0" *ngIf="(signUpForm.get('first_page.doctor_email').touched || signUpForm.get('first_page.doctor_email').dirty) 
                            && signUpForm.get('first_page.doctor_email').invalid 
                            && !signUpForm.get('first_page.doctor_email').errors?.email_exists">
                        Please enter valid email address.
                      </p>
                      <p class="mat-error mb-0" *ngIf="signUpForm.get('first_page.doctor_email')?.errors?.email_exists">
                        {{signUpForm.get('first_page.doctor_email').errors.email_exists}}, Please enter another email.
                      </p>

                    </div>
                    <!-- doctor_mobile -->
                    <div class="col-12">
                      <div
                        [ngClass]="[( signUpForm.get('first_page.doctor_mobile').touched && signUpForm.get('first_page.doctor_mobile').invalid || signUpForm.get('first_page.doctor_mobile').errors?.phone_error) ? 'custom-form inputContainer' : 'custom-form']">
                        <span
                          *ngIf="signUpForm.get('first_page.doctor_mobile').value !== null && signUpForm.get('first_page.doctor_mobile').value !== ''"
                          class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                        </span>
                        <input type="text" class="input_field pt-3 pe-3"
                          [ngStyle]="{'padding-left': signUpForm.get('first_page.doctor_mobile').value !== '' ? '40px' : '1rem' }"
                          required [mask]="mask" name="doctor_mobile" formControlName="doctor_mobile"
                          id="doctor_mobile" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Phone Number*
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="(signUpForm.get('first_page.doctor_mobile').errors?.phone_error || (signUpForm.get('first_page.doctor_mobile').touched && signUpForm.get('first_page.doctor_mobile').invalid)) && !signUpForm.get('first_page.doctor_mobile').dirty">
                        {{signUpForm.get('first_page.doctor_mobile').errors &&
                      signUpForm.get('first_page.doctor_mobile').errors.phone_error|| 'Please enter phone number.'}}
                      </p>
                      <p class="mat-error mb-0"
                        *ngIf="(signUpForm.get('first_page.doctor_mobile').errors?.phone_error || (signUpForm.get('first_page.doctor_mobile').touched && signUpForm.get('first_page.doctor_mobile').invalid)) && signUpForm.get('first_page.doctor_mobile').dirty">
                        {{signUpForm.get('first_page.doctor_mobile').errors &&
                      signUpForm.get('first_page.doctor_mobile').errors.phone_error|| 'Please
                      enter valid phone number.'}}
                    </p>
                  </div>
                  <!-- Password -->
                  <div class="col-12 form-group pe-md-0 ">
                    <div #passwordContainer
                      [ngClass]="[signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').invalid  ? '  b-10 m-h-56 custom-form inputContainer' : ' b-10 m-h-56 custom-form']">
                      <input type="text" [value]="displayedValue" (input)="handleInput($event)" autocomplete="off" class="input_field px-3 pt-3"
                        name="password" formControlName="doctor_password" autocomplete="new-password" required (focus)="showPasswordPolicyContainer()"
                        id="doctor_password" (keypress)="mainService.handleInputSpace($event)" (blur)="hidePasswordPolicyContainer()"/>
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Password*
                        </span>
                      </label>
                      <button style="    position: absolute;top: 9px;right: 10px;cursor: pointer;" type="button"
                        mat-icon-button class="d-inline me-2" matSuffix (click)="hidePwd = !hidePwd"
                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePwd">
                        <mat-icon>{{hidePwd ? 'visibility' : 'visibility_off'}}</mat-icon>
                      </button>
                      <div class="policy__main" *ngIf="passwordPolicyContainer">
                        <p style="font-weight: 600;font-size: 12px;line-height: 16px;color:#656B73;">Password must have at least:</p>
                        <div class="min_length policy__common"
                          [ngClass]="{
                           'validField': !signUpForm.get('first_page.doctor_password').errors?.minLength,
                           'invalidField': signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.minLength }">
                            <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                              *ngIf="!signUpForm.get('first_page.doctor_password').errors?.minLength" />
                            <img src="assets/img/png/red_cross.png" alt="incorrect"
                              style="width: 8px;height: 8px; margin-right: 3px;"
                              *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.minLength" />
                            <span>
                              8 characters
                            </span>
                          </div>
                          <div class="number policy__common"
                            [ngClass]="{
                            'validField': !signUpForm.get('first_page.doctor_password').errors?.number,
                            'invalidField': signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.number }">
                            <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                              *ngIf="!signUpForm.get('first_page.doctor_password').errors?.number" />
                            <img src="assets/img/png/red_cross.png" alt="incorrect"
                              style="width: 8px;height: 8px; margin-right: 3px;"
                              *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.number" />
                            <span>
                              1 number (0-9)
                            </span>
                          </div>
                          <div class="lowercase policy__common"
                            [ngClass]="{
                           'validField': !signUpForm.get('first_page.doctor_password').errors?.lowercase,
                           'invalidField': signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.lowercase }">
                            <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                              *ngIf="!signUpForm.get('first_page.doctor_password').errors?.lowercase" />
                            <img src="assets/img/png/red_cross.png" alt="incorrect"
                              style="width: 8px;height: 8px; margin-right: 3px;"
                              *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.lowercase" />
                            <span>
                              1 lowercase letter (a-z)
                            </span>
                          </div>
                          <div class="uppercase policy__common"
                            [ngClass]="{
                           'validField': !signUpForm.get('first_page.doctor_password').errors?.uppercase,
                           'invalidField': signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.uppercase }">
                            <img src="assets/img/png/tick2.png" alt="correct" style="width: 15px;height: 15px;"
                              *ngIf="!signUpForm.get('first_page.doctor_password').errors?.uppercase" />
                            <img src="assets/img/png/red_cross.png" alt="incorrect"
                              style="width: 8px;height: 8px; margin-right: 3px;"
                              *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.uppercase" />
                            <span>
                              1 uppercase letter (A-Z)
                            </span>
                          </div>
                          <div class="specialchar policy__common"
                            [ngClass]="{
                            'validField': !signUpForm.get('first_page.doctor_password').errors?.specialChar,
                            'invalidField': signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.specialChar}">
                            <img src="assets/img/png/tick2.png" alt="success" style="width: 15px;height: 15px;"
                              *ngIf="!signUpForm.get('first_page.doctor_password').errors?.specialChar" />
                            <img src="assets/img/png/red_cross.png" alt="incorrect"
                              style="width: 8px;height: 8px; margin-right: 2px;"
                              *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.specialChar" />
                            <span>
                              1 special character (!&#64;#$%^&*)
                            </span>
                          </div>
                        </div>
                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').invalid ">
                        Please enter valid password.
                      </p>
                    </div>

                    <!-- <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').invalid && !signUpForm.get('first_page.doctor_password').errors?.required && !signUpForm.get('first_page.doctor_password').errors?.trailingspace">
                      Please fulfill all password constraints.
                    </p>
                    <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.trailingspace && !signUpForm.get('first_page.doctor_password').errors?.required">
                      Please don’t end your password with blank space.
                    </p> -->
                        <!-- <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').invalid && signUpForm.get('first_page.doctor_password').dirty">
                      Please enter valid password (should be greater than 6 characters).
                    </p> -->
                        <!-- <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.minLength && !signUpForm.get('first_page.doctor_password').errors?.required">
                      Password must be at least 8 characters.
                    </p>
                    <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.lowercase">
                      Password must include at least one lowercase letter (a-Z).
                    </p>
                    <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.uppercase">
                      Password must include at least one uppercase letter (A-Z).
                    </p>
                    <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.number">
                      Password must include at least one number (0-9).
                    </p>
                    <p class="mat-error mb-0 ml-0 pl-0"
                      *ngIf="signUpForm.get('first_page.doctor_password').touched && signUpForm.get('first_page.doctor_password').errors?.specialChar">
                      Password must include at least one special character (!&#64;#$%^&*).
                    </p> -->
                  </div>
                  <!-- Continue -->
                  <div class="col-12 form-group mt-2">
                    <button button-primary-auth style="padding: 18px 85px !important" type="submit"
                      (click)="checkEmail('first_page')">Continue</button>
                  </div>
                </ng-container>

                <!-- step 3 -->
                <ng-container *ngSwitchCase="'view3'">
                  <!-- back -->
                  <div class="col-12 d-flex align-items-center  mt-5 mb-4 pointer p-0">
                    <img src="assets\img\png\arrow-left1.png" alt="" (click)="BackSingupValue('view2','view3')">
                    <h1 class="Back_button p-0 m-0 ms-3">Verify Your Email Address or Phone Number</h1>
                  </div>
                  <div class="select_boxes" [ngClass]="{'selected_boxes':selection_type==1}"
                    (click)="checkSelection(1)">
                    <div class="radio_box_icon">
                    </div>
                    <div>
                      <p style="color: #596775 !important">Email Address </p>
                      <p>{{signUpForm.get('first_page').get('doctor_email').value}}</p>
                    </div>
                  </div>

                  <div class="select_boxes" [ngClass]="{'selected_boxes':selection_type==2}"
                    (click)=" checkSelection(2)">
                    <div class="radio_box_icon">
                    </div>
                    <div>
                      <p style="color: #596775 !important">Phone Number </p>
                      <p>+1 {{transform(signUpForm.get('first_page').get('doctor_mobile').value)}} </p>
                    </div>
                  </div>
                  <div class="mt-4 ps-0">
                    <button autofocus button-primary-auth type="submit" style="padding: 18px 60px !important"
                      [disabled]="!selection_type" (click)="GenerateOtp('view4')">Send Verification Code</button>
                  </div>
                </ng-container>

                <!-- step 4 -->
                <ng-container formGroupName="second_page" *ngSwitchCase="'view4'">
                  <!-- back -->
                  <div class="col-12 d-flex align-items-center mt-5 mb-4 pointer"
                    >
                    <img src="assets\img\png\arrow-left1.png" alt="" (click)="BackSingupValue('view3','view4')">
                    <h1 class="Back_button m-0 ms-3 p-0" *ngIf="selection_type==1">Verification code has been sent to
                      {{signUpForm.get('first_page').get('doctor_email').value}}</h1>
                    <h1 class="Back_button m-0 ms-3 p-0" *ngIf="selection_type==2">Verification code has been sent to +1
                      {{transform(signUpForm.get('first_page').get('doctor_mobile').value)}}</h1>
                  </div>
                  <div class="col-12 form-group pe-md-0 mt-0">
                    <!-- <span class="d-inline-block w-100 h6  fw-bold"><span class="f-c-p-1 h6 fw-bold">Verification code
                        has
                        been sent to </span>{{email_otp}}</span> -->
                    <div
                      [ngClass]="[ (signUpForm.get('second_page.otp').touched && signUpForm.get('second_page.otp').invalid) || signUpForm.get('second_page.otp').errors?.emial_otp_none  ? 'custom-form  inputContainer mt-2' : 'custom-form mt-2']">
                      <input type="text" class="input_field pt-3 px-3" name="OTP" autocomplete="off" required
                        formControlName="otp" maxlength="6" autofocus appNumbersOnly id="OTP" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Enter Verification code
                        </span>
                      </label>
                    </div>
                    <p class="mat-error w-100 d-block"
                      *ngIf="(signUpForm.get('second_page.otp').touched && signUpForm.get('second_page.otp').invalid) ||  signUpForm.get('second_page.otp').errors?.emial_otp_none">
                      {{signUpForm.get('second_page.otp').errors &&
                      signUpForm.get('second_page.otp').errors.emial_otp_none ?
                      signUpForm.get('second_page.otp').errors.emial_otp_none : 'Please enter a
                      valid verification code'}}</p>
                    <div class="d-flex justify-content-between py-2">
                      <div class="h6"><span class="f-c-p-1">Request for new Verification code after</span>
                        <span class="notranslate ps-1">{{resendTime}}</span>
                      </div>
                      <div (click)="time==0 && GenerateOtp()" role="link"
                        [ngClass]="[time == null || time !== 0 ? 'f-c-p-3 fw-bold pointer' : 'd-blue  fw-bold pointer']"
                        id="Resend">
                        Resend</div>
                    </div>
                  </div>
                  <div class="col-12 mt-4">
                    <button autofocus button-primary-auth style="padding: 18px 75px !important;" type="submit"
                      id="Continue" (click)="verifyOtp()">Verify</button>
                  </div>
                </ng-container>

                <!-- step 5 -->
                <ng-container formGroupName="third_page" *ngSwitchCase="'view5'">
                  <div>
                    <!-- back -->
                    <div class="col-12 d-flex align-items-center mt-5 mb-4 pointer"
                      >
                      <img src="assets\img\png\arrow-left1.png" alt="" (click)="BackSingupValue('view4','view5')">
                      <h1 class="Back_button m-0 ms-3 p-0">Enter Business Details</h1>
                    </div>
                    <!-- business name -->
                    <div class="col-12 form-group pe-md-0 mb-3">
                      <div  [ngClass]="[ signUpForm.get('third_page.practice_name') && (signUpForm.get('third_page.practice_name').touched && signUpForm.get('third_page.practice_name').invalid)  ? 'custom-form inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3" style="padding-left: 15px;" name="practice_name" maxlength="50"
                        required formControlName="practice_name" autocomplete="off" id="practice_name"  (keypress)="mainService.handleInputSpace($event)"/>
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Business Name*
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.practice_name') && (signUpForm.get('third_page.practice_name').touched && signUpForm.get('third_page.practice_name').invalid && !signUpForm.get('third_page.practice_name').dirty)">
                        Please
                        enter business name.</p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.practice_name') && (signUpForm.get('third_page.practice_name').touched && signUpForm.get('third_page.practice_name').invalid && signUpForm.get('third_page.practice_name').dirty)">
                        Please
                        enter valid business name.</p>
                    </div>

                    <div class="col-md-12 form-group pe-md-0 mb-3">
                      <div
                        [ngClass]="[ signUpForm.get('third_page.website') && (signUpForm.get('third_page.website').touched && signUpForm.get('third_page.website').invalid)  ? 'custom-form inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3" style="padding-left: 15px;" required
                          name="website" autocomplete="none" placeholder="" trim 
                          formControlName="website" id="website" />
                          <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                              Business Website*
                            </span>
                          </label>
                      </div>
                      <p class=" mb-0 ms-0 ps-0" style="
                      font-size: 13px;
                      font-style: italic;
                      margin-top: 4px;
                  ">
                        Don't have website? You can enter a link to your social media page (e.g., Facebook, Instagram)
                      </p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.website') && (signUpForm.get('third_page.website').touched && signUpForm.get('third_page.website').invalid && !signUpForm.get('third_page.website').dirty)">
                        Please
                        enter business website.</p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.website') && (signUpForm.get('third_page.website').touched && signUpForm.get('third_page.website').invalid && signUpForm.get('third_page.website').dirty)">
                        Please
                        enter valid business website.</p>
                    </div>

                    <!-- industry select -->
                    <div class="col-12 form-group pe-md-0 mb-3">
                      <div
                        [ngClass]="[signUpForm.get('third_page.ind_id').touched && signUpForm.get('third_page.ind_id').invalid ? 'wrap m-h-56 h-100 h-56 border_10 d-block inputContainer_select' : 'wrap m-h-56 h-100 h-56 m-h-56 h-100 border_10 d-block']">
                        <div class="select w-100 h-100 h-56">

                          <select id="select_ind"
                            (change)="getSubIndustrylist($event);valueChange($event);onIndustryChanged();"
                            formControlName="ind_id"
                            class="select-text px-3 input_field fw-bold m-h-56 h-100 w-100 text-wap"
                            style="padding-top: 20px !important;" required>
                            <option class="w-100 py-3 px-2" *ngFor="let industry of industryList"
                              [value]="industry.ind_id">
                              {{industry.ind_name}}
                            </option>
                          </select>
                          <span class="select-highlight"></span>
                          <span class="select-bar"></span>
                          <span class="select-bar-1"></span>
                          <label class="select-label f-c-p-3" style="margin-top: -4px !important">Industry*</label>
                        </div>

                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.ind_id').touched && signUpForm.get('third_page.ind_id').invalid && !signUpForm.get('third_page.ind_id').dirty">
                        Please select
                        industry.
                      </p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.ind_id').touched && signUpForm.get('third_page.ind_id').dirty && signUpForm.get('third_page.ind_id').invalid">
                        Please select
                        valid industry.
                      </p>
                    </div>
                    <!-- subindustry select -->
                    <div class="col-12 form-group pe-md-0 mb-3">
                      <div
                        [ngClass]="[signUpForm.get('third_page.sub_ind_id').touched && signUpForm.get('third_page.sub_ind_id').invalid ? 'wrap m-h-56 h-100 h-56 border_10 d-block inputContainer_select' : 'wrap m-h-56 h-100 h-56  m-h-56 h-100 border_10 d-block']">
                        <div class="select w-100 h-100 h-56">
                          <select id="select_sub_ind" formControlName="sub_ind_id" (change)="valueChange($event)"
                            class="select-text px-3 input_field fw-bold m-h-56 h-100 w-100 text-wap"
                            style="padding-top: 20px !important;" required>
                            <option value="" class="d-none"></option>
                            <option class="w-100 py-3 px-2" *ngFor="let sub_industry of sub_industrys"
                              [value]="sub_industry.doctor_speciality">
                              {{sub_industry.speciality_name}}
                            </option>
                          </select>
                          <span class="select-highlight"></span>
                          <span class="select-bar"></span>
                          <span class="select-bar-1"></span>
                          <label class="select-label f-c-p-3" style="margin-top: -4px !important">Sub Industry*</label>
                        </div>
                      </div>

                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.sub_ind_id').touched && signUpForm.get('third_page.sub_ind_id').invalid && !signUpForm.get('third_page.sub_ind_id').dirty ">
                        Please select sub industry.</p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.sub_ind_id').touched && signUpForm.get('third_page.sub_ind_id').invalid && signUpForm.get('third_page.sub_ind_id').dirty">
                        Please select valid sub industry.</p>
                    </div>
                    <!-- industry name -->
                    <div class="col-md-12 form-group pe-md-0 mb-3" *ngIf="signUpForm.get('third_page.ind_id').value == 9999">
                      <div
                        [ngClass]="[signUpForm.get('third_page.ind_name') && (signUpForm.get('third_page.ind_name').touched && signUpForm.get('third_page.ind_name').invalid) ? 'custom-form inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3" style="padding-left: 15px;" required name="ind_name"
                          autocomplete="none" placeholder="" trim  formControlName="ind_name" id="ind_name" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Industry Name
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.ind_name') && (signUpForm.get('third_page.ind_name').touched && signUpForm.get('third_page.ind_name').invalid) && !signUpForm.get('third_page.ind_name').dirty ">
                        Please
                        enter industry name.</p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.ind_name') && (signUpForm.get('third_page.ind_name').touched && signUpForm.get('third_page.ind_name').dirty && signUpForm.get('third_page.ind_name').invalid)">
                        Please
                        enter valid industry name.</p>

                    </div>

                    <!-- sub name -->
                    <div class="col-md-12 form-group pe-md-0 mb-3"
                      *ngIf="signUpForm.get('third_page.ind_id').value == 9999 || signUpForm.get('third_page.sub_ind_id').value == 9999 ">
                      <div
                        [ngClass]="[ signUpForm.get('third_page.sub_ind_name') && (signUpForm.get('third_page.sub_ind_name').touched && signUpForm.get('third_page.sub_ind_name').invalid)  ? 'custom-form inputContainer' : 'custom-form']">
                        <input type="text" class="input_field pt-3" style="padding-left: 15px;" required
                          name="sub_ind_name" autocomplete="none" placeholder="" trim 
                          formControlName="sub_ind_name" id="sub_ind_name" />
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Sub Industry Name
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.sub_ind_name') && (signUpForm.get('third_page.sub_ind_name').touched && signUpForm.get('third_page.sub_ind_name').invalid && !signUpForm.get('third_page.sub_ind_name').dirty)">
                        Please
                        enter sub industry name.</p>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="signUpForm.get('third_page.sub_ind_name') && (signUpForm.get('third_page.sub_ind_name').touched && signUpForm.get('third_page.sub_ind_name').invalid && signUpForm.get('third_page.sub_ind_name').dirty)">
                        Please
                        enter valid sub industry name.</p>
                    </div>


                    <!-- REFERRAL CODE -->
                    <ng-container>
                      <p *ngIf="!referral_show" style="color: #1581E5 !important;font-size: 14px;font-weight: 600;"
                        (click)="referral_show=true" class="col-12 pointer">Do you have a referral code?</p>
                      <div class="col-12 form-group pe-md-0 mb-3" *ngIf="referral_show">
                        <div class="custom-form">
                          <input type="text" class="input_field pt-3 px-3"
                            [ngClass]="{singupModify: (!partnerId || !businessId) && (!signUpForm.get('third_page.referral_code') || signUpForm.get('third_page.referral_code') == '')}"
                            name="referral_code" autocomplete="none" tabindex="0" placeholder="" trim 
                            formControlName="referral_code" id="referral_code" />
                          <label for="text" class="label-name"
                            [ngClass]="{'font-change': font_size_change_lang[current_language] && font_size_change_lang[current_language].includes('referral_code')}">
                            <span class="content-name f-c-p-3">
                              Enter your code if referred by a Partner/Affiliate/Business
                            </span>
                          </label>
                        </div>
                        <!-- [ngClass]="[(signUpForm.get('third_page.referral_code').errors?.partner_id) ? 'custom-form inputContainer' : 'custom-form ']" -->
                        <!-- [ngStyle]="{'bottom': (businessId || partnerId) ? '16px' : ''}" -->
                        <p class="mat-error mb-0 ms-0 ps-0"
                          *ngIf="(signUpForm.get('third_page.referral_code').errors?.partner_id)">
                          {{signUpForm.get('third_page.referral_code').errors &&
                          signUpForm.get('third_page.referral_code').errors.partner_id}}
                        </p>
                      </div>
                    </ng-container>

                    <!-- captcha -->
                    <div class="col-12 d-flex justify-content-between align-items-center flex-wrap mb-4">
                      <!-- ente captcha -->
                      <div class="mt-2 form-group pe-md-0 m-0" style="width: 63%;">
                        <div
                          [ngClass]="[(signUpForm.get('third_page.captcha').touched && signUpForm.get('third_page.captcha').invalid) ? 'custom-form inputContainer' : 'custom-form ']">
                          <input type="text" class="input_field pt-3 px-3" name="captcha" autocomplete="none"
                            tabindex="0" placeholder="" trim  formControlName="captcha" maxlength="5" />
                          <label for="text"
                            [ngClass]="[signUpForm.get('third_page.captcha').value == '' ? '' : 'label-name']">
                            <span class="content-name f-c-p-3">
                              Enter Captcha
                            </span>
                          </label>
                        </div>
                        <p class="mat-error mb-0 ms-0 ps-0"
                          *ngIf="(signUpForm.get('third_page.captcha').touched && signUpForm.get('third_page.captcha').invalid && !signUpForm.get('third_page.captcha').dirty)">
                          {{signUpForm.get('third_page.referral_code').errors &&
                          signUpForm.get('third_page.referral_code').errors.partner_id}}
                        </p>
                        <p class="mat-error mb-0 ms-0 ps-0"
                          *ngIf="(signUpForm.get('third_page.captcha').touched && (signUpForm.get('third_page.captcha').invalid ))">
                          Please enter valid captcha
                        </p>
                      </div>

                      <!-- reload captcha -->
                      <div class="d-inline-flex" *ngIf="urlwindow">
                        <img [src]="urlwindow" class="captcha">
                        <img src="assets/img/png/reload.png" style="height: 20px; width: 20px;"
                          class="ms-3 mt-4 pointer" (click)="storeCaptcha()">
                      </div>
                    </div>


                    <!-- term and condition -->
                    <!-- <div class="col-12 py-2">
                      <label class="label-name pointer mb-0" style=" font-weight: normal;color: grey;">
                        <input type="checkbox" class="pointer" formControlName="TnC" id="terms">
                        <label for="terms"
                          [ngClass]="{'font-change': font_size_change_lang[current_language] && font_size_change_lang[current_language].includes('terms')}"
                          class="me-1 mb-0">
                          <span>By continuing, you acknowledge and agree to Denefits'</span></label>
                        <a target="_blank" class="text-decoration-none notranslate" style="color:#1581E5;" tappable
                          title="Terms & Conditions" routerLink="/terms/business-owner-terms">Terms & Conditions</a>
                      </label>
                      <p class="mat-error mb-0 ms-0 ps-0"
                        *ngIf="(signUpForm.get('third_page.TnC').touched && !signUpForm.get('third_page.TnC').value)">
                        Please accept terms & conditions.</p>
                    </div> -->

                    <div class="tnc_banner" [class.tnc_banner--accepted]="tncControl.value">
                      <ng-container *ngIf="!tncControl.value; else tncAccepted">
                        <div class="tnc_banner__row pointer" (click)="openTermsModal()">
                          <svg class="tnc_banner__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                            <circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5" />
                            <path d="M10 9v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            <circle cx="10" cy="6.25" r="1" fill="currentColor" />
                          </svg>
                          <span class="tnc_banner__text">
                            Before you continue, please review and accept the <a class="tnc_banner__link">Terms &amp;
                              Conditions</a>.
                          </span>
                        </div>
                        <p class="mat-error mb-0 ms-0 ps-0" *ngIf="tncControl.touched && !tncControl.value">
                          Please accept terms & conditions.</p>
                      </ng-container>
                      <ng-template #tncAccepted>
                        <div class="tnc_banner__row">
                          <svg class="tnc_banner__icon" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
                            <circle cx="10" cy="10" r="10" fill="currentColor" />
                            <path d="M6 10.2l2.6 2.6L14 7.4" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>
                          <span class="tnc_banner__text">You accepted the <strong>Terms &amp; Conditions</strong>.</span>
                          <a class="tnc_banner__view pointer" (click)="openTermsModal()">View</a>
                        </div>
                      </ng-template>
                    </div>

                    <!-- Continue -->
                    <div class="col-12 form-group mt-2">
                      <button button-primary-auth type="submit" style="padding: 20px 71px !important;"
                        [disabled]="!signUpForm.get('third_page.TnC').value" (click)="verify_captcha()">Sign Up</button>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Carousel -->
    <div class=" d-sm-none d-none d-md-block img_bg container_carousel flex-grow-1">
      <app-carousel></app-carousel>
    </div>
    <!-- ends -->
  </div>
</div>

<!-- Terms & Conditions modal -->
<div class="tnc_overlay" *ngIf="termsModalOpen" (click)="closeTermsModal()">
  <div class="tnc_dialog" (click)="$event.stopPropagation()">
    <span class="tnc_dialog__close pointer" (click)="closeTermsModal()">&times;</span>

    <div class="tnc_dialog__scroll_hint pointer" *ngIf="showTermsScrollHint" (click)="scrollTermsDown()">
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
        <path d="M1 1.5L8 8.5L15 1.5" stroke="#fff" stroke-width="2.5" stroke-linecap="round"
          stroke-linejoin="round"></path>
      </svg>
    </div>

    <div class="tnc_dialog__header">
      <img src="assets/img/svg/logo_login.svg" alt="Denefits" height="26">
    </div>

    <div class="tnc_dialog__tabs">
      <span class="tnc_dialog__tab tnc_dialog__tab--active">Terms &amp; Conditions</span>
    </div>

    <div class="tnc_dialog__content" #termsContent (scroll)="onTermsScroll($event)">
      <div class="tnc_dialog__content_inner" [innerHTML]="terms_html | safeHtml"></div>
    </div>

    <div class="tnc_dialog__footer">
      <div class="tnc_dialog__agree">
        <ng-container *ngIf="termsReadToEnd">
          <input type="checkbox" id="tnc_agree" [checked]="termsAgreeChecked" (change)="onTermsAgreeChange($event)">
          <label for="tnc_agree" class="pointer mb-0">
            <span>I<span *ngIf="signerName">, <strong>{{signerName}}</strong></span>, accept the
              <strong>Terms &amp; Conditions</strong>.</span>
          </label>
        </ng-container>
      </div>
      <div class="tnc_dialog__actions">
        <button type="button" class="tnc_btn tnc_btn--decline" (click)="declineTerms()">Decline</button>
        <button type="button" class="tnc_btn tnc_btn--accept" [disabled]="!termsAgreeChecked || !termsReadToEnd"
          (click)="acceptTerms()">Accept</button>
      </div>
    </div>
  </div>
</div>